/**
 * Pack Cart Logic
 * Handles cart interactions for grouped pack items
 */

document.addEventListener('click', async (e) => {
  const removeBtn = e.target.closest('.pack-remove-btn');
  if (removeBtn) {
    e.preventDefault();
    const keysStr = removeBtn.dataset.packKeys;
    if (!keysStr) return;

    // Keys string is comma separated: "key1,key2,key3,"
    const keys = keysStr.split(',').filter(k => k.trim() !== '');
    if (keys.length === 0) return;

    // Show loading state (Prestige theme custom event)
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    // Prepare updates payload for multiple items
    const updates = {};
    keys.forEach(k => {
      updates[k] = 0;
    });

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        throw new Error('Failed to update cart');
      }

      const cartData = await response.json();

      // Dispatch Prestige cart refresh event
      // If we are on the cart page, reload the page. Otherwise, refresh drawer.
      if (window.location.pathname === '/cart') {
        window.location.reload();
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (err) {
      console.error("[PackCart] Error removing pack:", err);
      alert('Hubo un error al remover el pack. Por favor intenta nuevamente.');
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    }
  }
});
